import { Routes, RouterModule } from '@angular/router';

const oebsConfigRoutes: Routes = [
];

export const OebsConfigExtRouter = RouterModule.forChild(oebsConfigRoutes);